import { useRef, useState } from 'react';
import type { DeleteBatchConfirm } from './batchDeletion.types';

/** The confirm step before `onDelete`; a confirm clicked again while the dialog fades out is ignored. */
export const useDeleteBatchConfirm = (onDelete: () => void): DeleteBatchConfirm => {
	const [opened, setOpened] = useState(false);
	const confirmed = useRef(false);

	return {
		opened,
		open: () => {
			confirmed.current = false;
			setOpened(true);
		},
		cancel: () => setOpened(false),
		confirm: () => {
			if (confirmed.current) {
				return;
			}
			confirmed.current = true;
			setOpened(false);
			onDelete();
		},
	};
};
